module.exports = __webpack_public_path__ + "static/image1-057b4490cfb6fb238deb1ef2dc956a6c.jpg";